import Alert from "react-bootstrap/Alert";

export default function MessageBox(props) {
  return (
    <div className="container">
      <Alert variant={props.variant || "secondary"}>{props.children}</Alert>
    </div>
  );
}
